$(document).ready(function() {

	function getCookie(cname) {
	    var name = cname + "=";
	    var ca = document.cookie.split(';');
	    for(var i=0; i<ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0)==' ') c = c.substring(1);
	        if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
	    }
	    return null;
	}

	function createCookie(cname, cvalue, exdays) {
	    var d = new Date();
	    d.setTime(d.getTime() + (exdays*24*60*60*1000));
	    var expires = "expires="+d.toUTCString();
	    document.cookie = cname + "=" + cvalue + "; " + expires;
	}

	function readCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	}

	function eraseCookie(name) {
		createCookie(name,"",-1);
	}

	//detects if under ie9 and displays a message.
	var ie = (function(){
	    var undef,
	        v = 3,
	        div = document.createElement('div'),
	        all = div.getElementsByTagName('i');

	    while (
	        div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
	        all[0]
	    );
	    return v > 4 ? v : undef;
	}());

	if (ie < 9 ){
		var popupCookie = getCookie("rememberpopup");
		if (popupCookie == null){
			var message = "<div class='browser-message'>\
						   <h3>Browser outdated.</h3>\
						   <p>You are using an outdated browser. To get the best experience from this website install Chrome, Firefox or Internet Explore 9+. Thank you.</p>\
						   <span class='btn js-message-close'>Close</span>\
						   <p><small>*By closing this message you accept the use of cookies on this website.</small></p>\
					   </div>",
			messageOverlay = "<div class='message-overlay'></div>";

			$(message).appendTo('.message-overlay');
			$('.message-overlay').show();
		}
	}

	var rememberOverlay = getCookie("rememberOverlay");

	if(rememberOverlay == null){
		$('.js-map-overlay').removeClass('hide');
	}

	$('.js-map-overlay').on('click', function(){
		$(this).addClass('hide');
		createCookie('rememberOverlay','Remember overaly',7);
	});

	$('.js-message-close').on('click', function(){
		createCookie('rememberpopup','Remember Popup',1);
		//readCookie(rememberpopup);
		$('.message-overlay').hide();
	});

	$('.js-map-button').on('click', function(){
		$('body').toggleClass('active-nav-map');
		$('body').removeClass('map-active-info');
		$('.js-map-overlay').hide();
		$('.active-label').removeClass('active-label');
		$('.map-button').find('h3').text('Map Key');
	});

	$('.label').on('click', function(){
		$('.active-label').removeClass('active-label');
		$(this).addClass('active-label');
		var number = $(this).attr('data-label'),
			popupInformation = MapPopupInformation[number];
		$('.js-MapPopupInformationContainer').html(popupInformation);
		$('body').removeClass('active-nav-map').addClass('map-active-info');
		$('.js-map-button').find('h3').text('Back To Map Key');
	});

	$('.js-menu-btn').on('click', function(){
		$('body').toggleClass('active-menu');
		$(this).find('.text').text(function(i, text){
          return text === "Menu" ? "Close" : "Menu";
      })
	});

	$('.js-footer-menu-btn').on('click', function(){
		$('body').toggleClass('active-footer-menu');
		$(this).find('.text').text(function(i, text){
          return text === "Menu" ? "Close" : "Menu";
      	})
		$('html, body').animate({
        	scrollTop: $(".copy").offset().top
		}, 400);
	});

	$('a[rel^="external"]').click( function() {
		window.open( $(this).attr('href') );
		return false;
	});

	$(window).resize(resize);

	$('.input, .textarea').on('focusin', function(){
		console.log("text");
		$(this).parent('div').find('label').hide();
	}).on('focusout', function(){
		if($(this).val() == ""){
			$(this).parent('div').find('label').show();
		}
	});

	$('body').on('submit', '#contact-form', function(){
		$(this).find(".loading-errors").html("<span class='loader'></span>");
		$('.error-container').removeClass('error-container');
		$('input').removeClass('error-input');

		var data = $(this).serialize();
		data = data + '&ajax=true';

		$.ajax({
			url: $(location).attr('href'),
			data: data,
			type: 'POST',
			success: function(data) {
				if (data != "Error") {
					//success message.
					if(data.success == false) {
						var error_message = $('<span>').addClass('error')
									.append($('<span>').addClass('icon'))
									.append($('<span>').addClass('text').text(data.error[0].message));
						$(this).find(".loading-errors").html(error_message);
						$(this).find('input[name="' + data.error[0].field + '"]').addClass('error-input');
						$(this).find('textarea[name="' + data.error[0].field + '"]').addClass('error-input');
						$('body').animate({scrollTop: $("#form").offset().top - 80},"slow");
					} else {
						$("#form").html(data.success);
					}
				} else {
					alert("There was a problem, sorry!");
				}
			}.bind(this),
			dataType: "json"
		});

		return false;

	}).on('click', '.js-seen-notification',function(){
		var timestamp = Date.now();
		setCookie('seen-notification', timestamp,365);
		$('.modal--active').removeClass('modal--active');
		$('body').removeClass('modal-active');
	});

	initParalax();
	updateParalaxPosition();
	setTimeout(repositionParalax,500);
	$('html').attr('data-useragent', navigator.userAgent);

	handleAccordions($("body"));

});

var MapPopupInformation = [
	$('<span>').append($('<h3>').text('Mac Birmingham'))
	.append($('<p>').html('MAC Birmingham is one of the most exciting cultural venues in the country, with galleries and exhibitions, cinema, theatre, dance, comedy and even crafts and workshops on throughout the year.'))
	.append($('<p>').html('MAC Birmingham is dedicated to bringing the arts into the community, with shows and exhibitions to inspire and courses and workshops that open up the artistic world to enquiring minds - young and old alike!'))
	.append($('<div>').addClass('btn-container')
		.append($('<a>').attr('href','/mac-birmingham').addClass('btn blue-btn').text('Find Out More'))
	),
	$('<span>').append($('<h3>').text('Nature Centre'))
	.append($('<p>').html('From reptiles and birds to furry favourites like monkeys and red pandas, there are new friends to meet everywhere you turn. You can even catch up with the keepers at feeding times to find out more about some of our animals and see them have their lunch!'))
	.append($('<div>').addClass('btn-container')
		.append($('<a>').attr('href','/nature-centre').addClass('btn blue-btn').text('Find Out More'))
	),
	$('<span>').append($('<h3>').text('Swan Lake Boating'))
	.append($('<p>').html('Take a trip out on the Boating Lake in a Swan Pedal Boat! It’s a fantastic way to relax and enjoy the beautiful surroundings, exploring the waters and seeing even more of Cannon Hill Park.'))
	.append($('<div>').addClass('btn-container')
		.append($('<a>').attr('href','/swan-lake-boating').addClass('btn blue-btn').text('Find Out More'))
	),
	$('<span>').append($('<h3>').text('Golden Lion'))
	.append($('<p>').html('The Golden Lion Inn is a Grade 2 Listed building, head down and have a look at a bit of history!'))
	.append($('<div>').addClass('btn-container')
		.append($('<a>').attr('href','/food-and-drink').addClass('btn blue-btn').text('Find Out More'))
	),
	$('<span>').append($('<h3>').text('Fun Park'))
	.append($('<p>').html('Simply the best day ever for toddlers to 10 year olds! The Fun Park is packed with games, rides and activities all designed for younger children (and some of them are suitable for parents too!).'))
	.append($('<div>').addClass('btn-container')
		.append($('<a>').attr('href','/fun-park').addClass('btn blue-btn').text('Find Out More'))
	),
	$('<span>').append($('<h3>').text('Golden Putter'))
	.append($('<p>').html('36 holes of mini golf madness! Golden Putter Mini Golf at Cannon Hill Park is a brilliant way to spend the day with friends and family. Plot your way through the twists and turns of the course, and watch out for those water hazards!\n'))
	.append($('<div>').addClass('btn-container')
		.append($('<a>').attr('href','/golden-putter').addClass('btn blue-btn').text('Find Out More'))
	),
	$('<span>').append($('<h3>').text('Toilets'))
	.append($('<p>').html('Public toilets, including disabled toilets are located off the Edgbaston Road car park.'))
	.append($('<div>').addClass('btn-container')
		.append($('<a>').attr('href','/facilities').addClass('btn blue-btn').text('Find Out More'))
	),
	$('<span>').append($('<h3>').text('Tennis Court'))
	.append($('<p>').html('If you’re looking for something a little more active when you visit Cannon Hill Park, we’ve got a range of sports facilities that you can make the most of!'))
	.append($('<div>').addClass('btn-container')
		.append($('<a>').attr('href','/sports').addClass('btn blue-btn').text('Find Out More'))
	),
	$('<span>').append($('<h3>').text('Land Train'))
	.append($('<p>').html('With a route right around the park, the Land Train stops off at all the major attractions, including the Fun Park, Golden Putter Mini Golf, Boating Lake, MAC, Birmingham Wildlife Conservation Park and the Front Gates.'))
	.append($('<div>').addClass('btn-container')
		.append($('<a>').attr('href','/land-train').addClass('btn blue-btn').text('Find Out More'))
	),
	$('<span>').append($('<h3>').text('Garden Tea Room'))
	.append($('<p>').html('The Garden Tea Room is near the Russell Road entrance of the park and has lots of lovely drinks, snacks and sandwiches in a classic old fashioned tea room style.'))
	.append($('<div>').addClass('btn-container')
		.append($('<a>').attr('href','/food-and-drink').addClass('btn blue-btn').text('Find Out More'))
	)
];

$(window).bind("load", function () {

});

$(window).on("scroll",function(){
	updateParalaxPosition();
});

function resize() {
	repositionParalax();
	updateParalaxPosition();
}

function check_width_max(maxwidth) {
    /**** CHECKS THAT THE WINDOW IS NARROWER THAN MAXWIDTH  ****/
   var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
   return parseInt(width) <= parseInt(maxwidth);
}

function check_width_min(minwidth) {
    /**** CHECKS THAT THE WINDOW IS WIDER THAN MINWIDTH  ****/
   var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
   return parseInt(width) >= parseInt(minwidth);
}

function check_height_max(maxheight) {
    /**** CHECKS THAT THE WINDOW IS SMALLER THAN MAXHEIGHT  ****/
   var height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
   return parseInt(height) <= parseInt(maxheight);
}

function check_height_min(minheight) {
    /**** CHECKS THAT THE WINDOW IS TALLER THAN MINHEIGHT  ****/
   var height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
   return parseInt(height) >= parseInt(minheight);
}

function matchHeights() {
   var classes = ['same_height', 'same_height_2', 's_height'];
   var height = 0;
   if (check_width_min(600)) {
       $.each(classes, function (_, className) {
           height = 0;
           $('.' + className).css("min-height", "");
           if(check_height_min(760) && check_width_min(760)){
               if(className === 'same_height_2'){
                   return;
               }
           }
           $('.' + className).each(function (i, obj) {
               if ($(this).outerHeight() > height) {
                   height = $(this).outerHeight();
               }
           });
           $('.' + className).css("min-height", height);
       });
   } else {
       $.each(classes, function (_, className) {
           $('.' + className).css("min-height", "");
       });
   }
}

function updateParalaxPosition(){
	if($(window).width < 960){ return; }
	var currentScroll = $(window).scrollTop() / 5;

	$('.paralaxContainer .js-paralax-item').each(function(){
		var translateX = 0,
			translateY = 0;

		if($(this).is('[data-x]')){
			translateX = (parseFloat($(this).attr('data-x')) * currentScroll / 2) * 10;
		}

		if($(this).is('[data-y]')){
			translateY = (parseFloat($(this).attr('data-y')) * currentScroll / 2) * 10;
		}

		$(this).css({
			"transform" : "translate("+ translateX + "%," + translateY +"%)",
			"-ms-transform": "-ms-translate("+ translateX + "%," + translateY +"%)",
			"-webkit-transform": "-webkit-translate("+ translateX + "%," + translateY +"%)",
			"-moz-transform": "-moz-translate("+ translateX + "%," + translateY +"%)"
		})
	});

}

function initParalax(){
	$('body').append($('<div>').addClass('paralaxContainer'));

	$('.js-paralax-item').each(function(index){
		$(this).attr('data-parlax-id',index);
		$('.paralaxContainer').append($(this).clone());
		$(this).addClass('hidden');
	});
	setTimeout(repositionParalax,200);
}

function repositionParalax(){
	if($(window).width() < 960){
		$('.paralaxContainer').css({ height: 0, width: 0 });
		return;
	}
	$('.paralaxContainer').css({ height: $('html').outerHeight(), width: $(window).width() });
	$('.paralaxContainer .js-paralax-item').each(function(){
		var position = $('.js-paralax-item.hidden[data-parlax-id="' + $(this).attr('data-parlax-id') + '"]').offset();
		$(this).css({
			top: position.top,
			left: position.left
		})
	});
}

function handleAccordions($element) {
	$element.on('click', '.js-toggle-accordion', function () {
		var $accordion = $(this).parent().parent('.accordion');

		$accordion.toggleClass('accordion--active');
		if ($accordion.is(".accordion--active")) {
			$accordion.children('.accordion__body').stop().slideDown('fast');
		} else {
			$accordion.children('.accordion__body').stop().slideUp('fast');
		}

		return false;
	});
}

function setCookie(name,value,expiresDays){
	var d = new Date();
	d.setTime(d.getTime() + (expiresDays * 24 * 60 * 60 * 1000));
	var expires = "expires=" + d.toUTCString();
	document.cookie = name + "=" + value + "; path=/; " + expires;
}
